import { render } from "./BookingFormHotelPreferences.vue?vue&type=template&id=57d9ceea"
import script from "./BookingFormHotelPreferences.vue?vue&type=script&lang=js"
export * from "./BookingFormHotelPreferences.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__